import { Check, Minus, TrendingUp, ShieldCheck, Users } from "lucide-react";
import { SectionHead } from "@/components/home/CategoriesGrid";

const ROWS = [
  ["Foco de materiales", "Scrap técnico y mermas industriales no estandarizadas", "Envases y embalajes domiciliarios"],
  ["Lotes a medida (B2B)", true, false],
  ["Subastas rápidas y venta directa", true, false],
  ["Ingreso para el generador", true, false],
  ["Certificado de valorización y CO₂ por lote", true, "Reporte agregado del sistema"],
  ["Acceso para liceos técnicos y makers", true, false],
];

const Cell = ({ v, strong }) =>
  v === true ? <Check className="w-5 h-5 text-[#00b37a] mx-auto" /> : v === false ? <Minus className="w-5 h-5 text-slate-300 mx-auto" /> : <span className={strong ? "font-medium text-[#05130e]" : ""}>{v}</span>;

const PILLARS = [
  { icon: TrendingUp, t: "Económico", d: "Convierte un gasto de vertedero en ingreso o ahorro en materias primas secundarias." },
  { icon: ShieldCheck, t: "Cumplimiento ESG / Ley REP", d: "Reportes y certificados de trazabilidad y valorización con toneladas de CO₂ mitigadas." },
  { icon: Users, t: "Impacto comunitario", d: "Donación o bajo costo para liceos técnicos, artesanos y emprendedores de la economía popular." },
];

export const Comparison = () => (
  <section className="bg-white border-y border-slate-200" data-testid="comparison-section">
    <div className="max-w-[1400px] mx-auto px-5 lg:px-8 py-24">
      <SectionHead eyebrow="Diferenciación" title="No es un clasificado de basura: es simbiosis industrial" text="Los GRANSIC tradicionales (como ReSimple) gestionan envases estandarizados. terraloop atiende el scrap técnico B2B que queda fuera." />
      <div className="grid md:grid-cols-3 gap-5 mb-14">
        {PILLARS.map((p) => (
          <div key={p.t} className="p-6 rounded-2xl bg-[#f4f7f6] border border-slate-200/80 hover:border-[#00f2a1] transition-colors duration-300" data-testid={`pillar-${p.t.split(" ")[0].toLowerCase()}`}>
            <p.icon className="w-7 h-7 text-[#00b37a] mb-4" />
            <h3 className="font-semibold text-lg text-[#05130e]">{p.t}</h3>
            <p className="text-sm text-slate-600 mt-2 leading-relaxed">{p.d}</p>
          </div>
        ))}
      </div>
      <p className="sm:hidden text-xs text-slate-500 mb-2">Desliza la tabla hacia el lado →</p>
      <div className="overflow-x-auto rounded-2xl border border-slate-200">
        <table className="w-full min-w-[640px] text-sm" data-testid="comparison-table">
          <thead>
            <tr className="text-left">
              <th className="p-4 bg-[#f4f7f6] font-medium text-slate-500 w-[38%]">Capacidad</th>
              <th className="p-4 bg-[#0a1f18] text-[#00f2a1] font-display font-bold text-center">terraloop.cl</th>
              <th className="p-4 bg-[#f4f7f6] font-medium text-slate-500 text-center">GRANSIC tradicional</th>
            </tr>
          </thead>
          <tbody>
            {ROWS.map(([k, a, b]) => (
              <tr key={k} className="border-t border-slate-100 hover:bg-[#f4f7f6]/60 transition-colors">
                <td className="p-4 text-slate-700">{k}</td>
                <td className="p-4 text-center bg-[#00f2a1]/5"><Cell v={a} strong /></td>
                <td className="p-4 text-center text-slate-500"><Cell v={b} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </section>
);
